export default __webpack_public_path__ + "static/media/rambouillet24.124b6efc.jpg";